import React from 'react';
import SearchableFiltersList from './SearchableFiltersList';

function SingleSelectFilterSection(props) {
  return <SearchableFiltersList inputType="radio" {...props} />;
}

export default SingleSelectFilterSection;
